import * as React from "react"
import { Show } from "react-admin"
import { useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import BarChartIcon from "@mui/icons-material/BarChart"
import ScheduleIcon from "@mui/icons-material/Schedule"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import Form from "./form"

function DeviceShow(): JSX.Element  {
    const translate = useTranslate()
    
    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]
    
    return (
        <Show actions={<RecordActionsTabs subTabs={subTabs}/>}>
            <Form readonly />
        </Show>
    )
}

export default DeviceShow
